import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Icon } from '@types-custom/models/ui/icon-model';
import { Router } from '@angular/router';
import { RouteNamesEnum } from '@citizen/routes/routes';
import { IDynamicFilterModel } from '@types-custom/models/ui/dynamic-filter';
import { SearchAuditUserService } from '@shared/services/audit-service/search-audit-user.service';
import { IGridPageModel } from '@types-custom/models/ui/grid-page-model';
import { GridTypeEnum, gridTableheadersMap } from '@shared/utils/mappers/grid-mapper';
import { BehaviorSubject, Subject } from 'rxjs';
import { IGridTableCellDispatcher } from '@types-custom/models/ui/grid-table-model';
import { SdkDynamicFiltersService } from '@sdk/services/sdk-dynamic-filters/sdk-dynamic-filters.service';
import { IAuditModel } from '@shared/models/audit.model';
import { GridAuditUserService } from '@shared/services/audit-service/grid-audit-user.service';
import { IUniqueModalModel } from '@types-custom/models/ui/modal.model';
import { ModalErrorComponent } from '../modal-error/modal-error.component';
import { ModalService } from '@ui-core/services/modal/modal.service';

@Component({
  selector: 'search-audit-user',
  templateUrl: './search-audit-user.component.html',
  styleUrls: ['./search-audit-user.component.scss'],
})
export class SearchAuditUserComponent implements OnInit {
  @Input() funcionality: string;
  @Output() handleValue = new EventEmitter<any>();
  Icon = Icon;
  icon = Icon.manage_accounts_w;
  layerName = GridTypeEnum.ManageUserAudit;
  isAllowDownload = false;
  editColumnDispatcher = new Subject<IGridTableCellDispatcher>();
  dataSource = new BehaviorSubject<[]>([]);
  gridPageProps: IGridPageModel = {
    headers: gridTableheadersMap([this.editColumnDispatcher])[this.layerName],
    dataSource: this.manageAuditService,
    isAllowDownloadExcel: this.isAllowDownload,
    isAllowDownloadPdf: false,
    dispatcher: this.editColumnDispatcher
  };

  dynamicFiltersModel: IDynamicFilterModel =
    this.manageAuditService.generateDynamicFIltersModel();

  constructor(
    private router: Router,
    public manageAuditService: SearchAuditUserService,
    private sdkDynamicFiltersService: SdkDynamicFiltersService,
    public gridAuditUserService: GridAuditUserService,
    private modalService: ModalService,
  ) {
    this.sdkDynamicFiltersService.setFilters(this.manageAuditService);
    this.manageAuditService.init();
    this.editColumnDispatcher.subscribe(this.handleSelectCard.bind(this));


  }

  ngOnInit(): void {
    this.gridPageProps.dataSource.data$.subscribe({
      next: (response:any) => {
        this.handleDataChange(response)
      }
    })
  }

  navigateToVisor(): void {
    this.router.navigate([RouteNamesEnum.MapViewer]);
  }

  modalError(msg?: string) {
    const modal: IUniqueModalModel = {
      toRender: {
        component: ModalErrorComponent,
        data: { errorMessage: msg }
      },
      headerBackgroundClass: 'bg-color-background-3',
      modalClass: '#FF5B5B',
      leftLineClass: 'bg-color-state-4',
    };
    this.modalService.confirmationModal(modal);
  }

  handleDataChange(data: any) {

    if (data.length === 0) {
      this.modalError('No se ha encontrado la información solicitada')
    }
  }

  handleSelectCard(columnAction: IGridTableCellDispatcher): void {

    const auditModel: IAuditModel = {
      code: this.funcionality,
      data: columnAction.row,
      renderGridUser: true
    };
    this.gridAuditUserService.setModelAudit(auditModel);

    this.handleValue.emit(auditModel);
  }
}
